import {FC, forwardRef, HTMLAttributes} from 'react';
import {twMerge} from 'tailwind-merge';
import {Option} from 'types';

const Item: FC<{
    onClick: (option: Option) => void;
    option: Option;
}> = ({onClick, option}) => {
    return (
        <div
            aria-selected={false}
            className="flex cursor-pointer select-none items-center rounded px-2 py-1 hover:bg-grey-200 active:bg-grey-100"
            data-value={option.value}
            onClick={() => onClick(option)}
            onKeyDown={() => {}}
            role="option"
            tabIndex={0}
        >
            <div className="flex-1">
                <div>{option.label}</div>
                <div className="text-sm text-grey-600">{option.value}</div>
            </div>
        </div>
    );
};

type InsertVariablesContainerProps = {
    className?: HTMLAttributes<HTMLDivElement>['className'];
    onSelect: (option: Option) => void;
    options: Option[];
};

export const InsertVariablesContainer = forwardRef<
    HTMLDivElement,
    InsertVariablesContainerProps
>(({className, onSelect, options}, ref) => {
    return (
        <div className="bg-white">
            <div
                className={twMerge(
                    'pointer-events-auto flex flex-col rounded border border-blue-300 bg-white p-2 max-h-80 overflow-y-auto scroll-shadow-y',
                    className,
                )}
                ref={ref}
            >
                {options.map((option) => (
                    <Item
                        key={option.value}
                        onClick={() => onSelect(option)}
                        option={option}
                    />
                ))}
            </div>
        </div>
    );
});

InsertVariablesContainer.displayName = 'InsertVariablesContainer';

export default InsertVariablesContainer;
